import { useMediaQuery } from "react-responsive";
import { CodiMeSymbolLogotype } from "./logo";
import { personalInfoLink, serviceLink, personalInfoLinkEn, serviceLinkEn } from "../constants";

type CodiMeFooterProps = {
  baseColor?: string; //baseColor: black/white
};

const TextLine = ({ baseColor }: CodiMeFooterProps) => {
  if (baseColor == "black") return <span className="trans-white-9">|</span>;
  else return <span className="trans-gray-950-20">|</span>;
};

//baseColor: black/white
const CodiMeFooter = ({ baseColor = "black" }: CodiMeFooterProps) => {
  const isMobile = useMediaQuery({
    query: "(max-width:1199px)",
  });

  if (isMobile)
    return (
      <div className={`footer-box ${baseColor === "black" ? "" : "white-basecolor"}`}>
        <CodiMeSymbolLogotype
          color={baseColor === "black" ? "white" : "#0E0305"}
          width={94.33}
          height={20}
        />
        <div className="column flex-start gap-16">
          <span className="body2-700">(주) 코디미</span>
          <p className="caption-500" style={{ margin:0 }}>
            대표자: 정지혜 <TextLine baseColor={baseColor} /> 사업자등록번호: 255-87-02614{" "}
            <TextLine baseColor={baseColor} />
            <br />
            경기도 수원시 장안구 서부로 2066, 23101호(천천동, 성균관대학교 제 1공학관{" "}
            <TextLine baseColor={baseColor} /> 070-7174-2091 <TextLine baseColor={baseColor} />
            <br />
            contact@codime.io <TextLine baseColor={baseColor} /> 통신판매업신고번호:
            제2024-수원장안-0452호
            {/* <TextLine baseColor={baseColor} />
            <br />
            <a
              target="_blank"
              href="사업자정보확인"
              className="text-underline"
            >
              {"사업자정보확인 >"}
            </a> */}
          </p>
          <div className="row justify-start gap-8 align-center">
            <a target="_blank" href={serviceLink} className="body2-400 anchor" style={{ textDecoration: 'none' }}>
              이용약관
            </a>
            <TextLine baseColor={baseColor} />
            <a
              target="_blank"
              href={personalInfoLink}
              className="body2-700 text-underline anchor"
              style={{ textDecoration: 'none' }}
            >
              개인정보처리방침
            </a>
          </div>
        </div>
        <span className="caption-500 copyright">Copyright 2025 CodiMe Co., Ltd. All rights reserved.</span>
      </div>
    );
  //desktop
  else
    return (
      <div className={`desktop-potoo-footer-box ${baseColor === "black" ? "" : "white-basecolor"}`}>
        <div className="desktop-potoo-footer-container">
          <div className="row">
            <div
              style={{
                width: 94.33,
                height: 20,
              }}
            >
              <CodiMeSymbolLogotype
                color={baseColor === "black" ? "white" : "#0E0305"}
                width={94.33}
                height={20}
              />
            </div>
            <div className="column flex-start gap-9" style={{ marginLeft: 30 }}>
              <span className="body2-700">(주) 코디미</span>
              <p className="caption-500" style={{ margin:0 }}>
                대표자: 정지혜 <TextLine baseColor={baseColor} /> 사업자등록번호: 255-87-02614{" "}
                <TextLine baseColor={baseColor} /> 경기도 수원시 장안구 서부로 2066, 23101호(천천동, 성균관대학교 제 1공학관 <TextLine baseColor={baseColor} /> 070-7174-2091{" "}
                <TextLine baseColor={baseColor} />{" "}
                contact@codime.io <TextLine baseColor={baseColor} /> 통신판매업신고번호:
                제2024-수원장안-0452호
                {/* <TextLine baseColor={baseColor} />{" "} */}
                {/* <a
                  target="_blank"
                  href="사업자정보확인"
                  className="text-underline"
                >
                  {"사업자정보확인 >"}
                </a> */}
              </p>
              <div className="row justify-start gap-8 align-center">
                <a target="_blank" href={serviceLink} className="body2-400 anchor" style={{ textDecoration: 'none' }}>
                  이용약관
                </a>
                <TextLine baseColor={baseColor} />
                <a target="_blank" href={personalInfoLink} className="body2-700 anchor" style={{ textDecoration: 'none' }}>
                  개인정보처리방침
                </a>
              </div>
            </div>
          </div>

          <span
            className="caption-500 no-enter copyright"
            style={{ marginLeft: 32, alignSelf: "end" }}
          >
            Copyright 2025 CodiMe Co., Ltd. All rights reserved.
          </span>
        </div>
      </div>
    );
};

const CodiMeFooterEn = ({ baseColor = "black" }: CodiMeFooterProps) => {
  const isMobile = useMediaQuery({
    query: "(max-width:1199px)",
  });

  if (isMobile)
    return (
      <div className={`footer-box ${baseColor === "black" ? "" : "white-basecolor"}`}>
        <CodiMeSymbolLogotype
          color={baseColor === "black" ? "white" : "#0E0305"}
          width={94.33}
          height={20}
        />
        <div className="column flex-start gap-16">
          <span className="body2-700">CodiMe Co.,Ltd.</span>
          <p className="caption-500" style={{ margin:0 }}>
            CEO: Jihye Jung <TextLine baseColor={baseColor} /> Business Number: 255-87-02614{" "}
            <TextLine baseColor={baseColor} />
            <br />
            23101, 2066, Seobu-ro, Jangan-gu, Suwon-si, Gyeonggi-do, Republic of Korea <TextLine baseColor={baseColor} /> +82)70-7174-2091{" "}
            <TextLine baseColor={baseColor} /> contact@codime.io
          </p>
          <div className="row justify-start gap-8 align-center">
            <a target="_blank" href={serviceLinkEn} className="body2-400 anchor" style={{ textDecoration: 'none' }}>
              Terms of Service
            </a>
            <TextLine baseColor={baseColor} />
            <a
              target="_blank"
              href={personalInfoLinkEn}
              className="body2-700 text-underline anchor"
              style={{ textDecoration: 'none' }}
            >
              Privacy Policy
            </a>
          </div>
        </div>
        <span className="caption-500 copyright">Copyright 2025 CodiMe Co., Ltd. All rights reserved.</span>
      </div>
    );
  //desktop
  else
    return (
      <div className={`desktop-potoo-footer-box ${baseColor === "black" ? "" : "white-basecolor"}`}>
        <div className="desktop-potoo-footer-container">
          <div className="row">
            <div
              style={{
                width: 94.33,
                height: 20,
              }}
            >
              <CodiMeSymbolLogotype
                color={baseColor === "black" ? "white" : "#0E0305"}
                width={94.33}
                height={20}
              />
            </div>
            <div className="column flex-start gap-9" style={{ marginLeft: 30 }}>
              <span className="body2-700">CodiMe Co.,Ltd.</span>
              <p className="caption-500" style={{ margin:0 }}>
                CEO: Jihye Jung <TextLine baseColor={baseColor} /> Business Number: 255-87-02614{" "}
                <TextLine baseColor={baseColor} /> 23101, 2066, Seobu-ro, Jangan-gu, Suwon-si, Gyeonggi-do, Republic of Korea{" "}
                <TextLine baseColor={baseColor} /> +82)70-7174-2091{" "}
                <TextLine baseColor={baseColor} /> contact@codime.io
              </p>
              <div className="row justify-start gap-8 align-center">
                <a target="_blank" href={serviceLinkEn} className="body2-400 anchor" style={{ textDecoration: 'none' }}>
                  Terms of Service
                </a>
                <TextLine baseColor={baseColor} />
                <a target="_blank" href={personalInfoLinkEn} className="body2-700 anchor" style={{ textDecoration: 'none' }}>
                  Privacy Policy
                </a>
              </div>
            </div>
          </div>

          <span
            className="caption-500 no-enter copyright"
            style={{ marginLeft: 32, alignSelf: "end" }}
          >
            Copyright 2025 CodiMe Co., Ltd. All rights reserved.
          </span>
        </div>
      </div>
    );
};

export { CodiMeFooter, CodiMeFooterEn };
